import Stack from '@mui/material/Stack'
import Box from '@mui/material/Box'
import { useTheme, styled, useMediaQuery, Typography } from '@mui/material'
import clsx from 'clsx'
import useContentful from '../contexts/useContentful'

const SIZES_MOBILE = [40, 32, 28, 32, 40]
const SIZES_DESKTOP = [48, 40, 32, 40, 48]

const RadioCircle = styled(Box)(({ theme, size, selected }) => ({
  width: size,
  height: size,
  borderRadius: '50%',
  border: `2px solid ${selected ? `${theme.palette.primary.lighter} !important` : theme.palette.neutral.light}`,
  backgroundColor: selected ? `${theme.palette.primary.main} !important` : 'transparent',
  display: 'inline-grid',
  justifyContent: 'center',
  alignSelf: 'center',
  alignItems: 'center',
  transition: theme.transitions.create(['background-color']),
  '&:hover': {
    backgroundColor: theme.palette.primary.lightest,
  },
}))

const LikertScale = ({
  value = -1,
  onChange,
}) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const {
    other,
  } = useContentful()

  const labels = other?.[0]?.fields?.likertOptions || []

  const handleClick = index => {
    onChange?.(index)
  }

  return (
    <Stack
      role="radiogroup"
      aria-label="Likert scale"
      display="grid"
      gap={{
        sm: 1,
      }}
      gridTemplateColumns={{
        xs: 'repeat(5, 50px)',
        sm: undefined,
      }}
      gridAutoFlow={{
        sm: 'column',
      }}
      justifyContent="space-between"
    >
      {labels.map((label, index) => {
        const showLabel = !isMobile || index === 0 || index === labels.length - 1

        return (
          <Box
            key={index}
            onClick={() => handleClick(index)}
            role="radio"
            aria-checked={value === index}
            tabIndex={index}
            sx={{
              display: 'inline-grid',
              gridTemplateRows: {
                xs: `${SIZES_MOBILE[0]}px 1fr`,
                sm: `${SIZES_DESKTOP[0]}px 1fr`,
              },
              gap: 1,
              justifyContent: 'center',
              justifyItems: 'center',
              cursor: 'pointer',
              justifyItems: {
                xs: index < 2 ? 'flex-start' : index > 2 ? 'flex-end' : 'center',
                sm: 'center',
              },
            }}
            className={clsx({ selected: value === index })}
            onKeyDown={e => {
              if (e.key === 'Enter' || e.key === ' ') {
                handleClick(index)
              }
            }}
          >
            <RadioCircle
              size={isMobile ? SIZES_MOBILE[index] : SIZES_DESKTOP[index]}
              selected={value === index}
            />
            <Typography
              variant="labelUpper"
              sx={{
                display: showLabel ? 'inline-grid' : 'none',
                alignItems: 'flex-start',
                textAlign: {
                  xs: index === labels.length - 1 ? 'right' : 'left',
                  sm: 'center',
                },
                maxWidth: 100,
              }}
            >
              {label}
            </Typography>
          </Box>
        )
      })}
    </Stack>
  )
}

export default LikertScale
